import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../../packages/JsonQuery';
import { selectOfferType } from 'shared/selectors/jsonQuery';

export const selectSquareMeterAreaFilters = createSelector(selectOfferType, offerType => {
  switch (offerType) {
    case FOfferType.Room:
      return ['general', 'room', 'kitchen'] as const;
    case FOfferType.Garage:
      return ['general'] as const;
    default:
      return ['general', 'kitchen', 'living'] as const;
  }
});
